import { render, staticRenderFns } from "./StockWarningReport.vue?vue&type=template&id=3541b3aa&scoped=true"
import script from "./StockWarningReport.vue?vue&type=script&lang=js"
export * from "./StockWarningReport.vue?vue&type=script&lang=js"
import style0 from "./StockWarningReport.vue?vue&type=style&index=0&id=3541b3aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541b3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3541b3aa')) {
      api.createRecord('3541b3aa', component.options)
    } else {
      api.reload('3541b3aa', component.options)
    }
    module.hot.accept("./StockWarningReport.vue?vue&type=template&id=3541b3aa&scoped=true", function () {
      api.rerender('3541b3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/StockWarningReport.vue"
export default component.exports